import React from "react";
import { ArrowRight } from "lucide-react";
import { heroImage } from "../mock";

export default function Hero() {
  return (
    <section id="home" className="relative h-[720px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt="Blank t-shirts ready to print" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[color:var(--dms-navy)]/55" />
      </div>
      <div className="relative z-10 h-full max-w-7xl mx-auto px-5 lg:px-8 flex flex-col items-center justify-center text-center text-white">
        <p className="kicker fade-up">Design My Story</p>
        <h1 className="font-serif text-[52px] md:text-[80px] leading-[1.02] mt-6 tracking-tight fade-up">
          Wear your story.
        </h1>
        <p className="mt-6 text-white/85 text-lg fade-up">Create a T-shirt that is uniquely yours.</p>
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 fade-up">
          <a href="#tshirts" className="btn-peach">View more <ArrowRight className="w-4 h-4" /></a>
          <a href="#custom" className="btn-outline-light">Create My Design</a>
        </div>
      </div>
    </section>
  );
}
